/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const AdministrationIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    viewBox="0 0 32 32"
    onClick={props.onClick}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path d="M29.25,29.7755102 L19.25,29.7755102" />
      <path d="M14.25,5.28571429 C20.4625,5.28571429 25.5,10.2191837 25.5,16.3061224 L25.5,29.7755102" />
      <path d="M14.25,7.73469388 L14.25,4.67346939 C14.25,2.98244898 12.85,1.6122449 11.125,1.6122449 C9.3975,1.6122449 8,2.98244898 8,4.67346939 L8,7.73469388 C5.0625,8.93346939 3,11.7693878 3,15.0816327 L3,17.5306122 L19.25,17.5306122 L19.25,15.0816327 C19.25,11.7693878 17.185,8.93346939 14.25,7.73469388 Z" />
    </g>
  </svg>
);

export default AdministrationIcon;
